import renderProps from '../renderProps';

export default renderProps(doc => ({ doc }), {
  callee: '<Get>',
  example: '<Get db={name|options} ... />'
});
